import { render, staticRenderFns } from "./CustomerSalesTab.vue?vue&type=template&id=34822ef8"
import script from "./CustomerSalesTab.vue?vue&type=script&lang=js"
export * from "./CustomerSalesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports